<script>
    import { getContext } from 'svelte';
    import { Policy } from "@Store";
    import Question from "@components/Question.svelte";
    import { validateApplicant, getAnswerText } from "@helpers/validator";
    import { applicantQuestions } from "@helpers/questions";

    const CONTEXT = getContext('CONTEXT');

    // Call the function to get the questions object
    $: questionsList = applicantQuestions($Policy);

    function handleAnswer(e) {
        CONTEXT.handleAnswer(e);
    }


    $: valid = validateApplicant($Policy);  

    $: {
        CONTEXT.routeValidation.update(validation => ({
            ...validation,
            applicant: valid
        }));
    }

    function handleEffectiveDateUpdate(e) {
        CONTEXT.handleEffectiveDateUpdate(e);
    }
    
</script>

<div class="page-container">
    <div class="questions-wrapper">
        {#if questionsList.start_date_question}
            <Question question={questionsList.start_date_question} policy={$Policy} on:updatedEffectiveDate={handleEffectiveDateUpdate} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.named_insured_question}
            <Question question={questionsList.named_insured_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.operating_name_question}
            <Question question={questionsList.operating_name_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.mailing_address_question}
            <Question question={questionsList.mailing_address_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.contact_name_title_question}
            <Question question={questionsList.contact_name_title_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.email_question}
            <Question question={questionsList.email_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.phone_number_question}
            <Question question={questionsList.phone_number_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.years_in_operation_question}
            <Question question={questionsList.years_in_operation_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.ccpa_member_question}
            <Question question={questionsList.ccpa_member_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.licensed_practitioner_question}
            <Question question={questionsList.licensed_practitioner_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
        {#if questionsList.disciplinary_action_question}
            <Question question={questionsList.disciplinary_action_question} policy={$Policy} on:answered={(e) => handleAnswer(e.detail)} />
        {/if}
    </div>
</div>

<style>
/* Section Container Styles */
.page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 1rem;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.questions-wrapper {
    width: 100%;
    max-width: 500px;
    margin-bottom: 2rem;
}
.section-container {
    width: 100%;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border: 2px solid #e9ecef;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 2rem 1.5rem;
    margin: 2rem 0;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
}

.section-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding-bottom: 1.5rem;
    border-bottom: 2px solid #e9ecef;
}

.section-icon {
    font-size: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #fff3cd 0%, #fff8e1 100%);
    border-radius: 16px;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(255, 193, 7, 0.15);
}

.section-header h1 {
    font-size: 1.375rem;
    font-weight: 600;
    color: #1d1d1f;
    margin: 0;
    line-height: 1.3;
    letter-spacing: -0.01em;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.sub-questions {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.sub-question {
    position: relative;
}

@media (max-width: 768px) {
    .section-container {
        padding: 1.5rem 1rem;
        border-radius: 16px;
    }

    .section-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
    }

    .section-header h1 {
        font-size: 1.25rem;
    }

    .section-icon {
        width: 48px;
        height: 48px;
        font-size: 1.75rem;
    }

    .sub-question {
        padding-left: 1rem;
    }

    .sub-question::before {
        width: 3px;
    }
}</style>